import { render, staticRenderFns } from "./MatchingItemImages.vue?vue&type=template&id=74034a5f"
import script from "./MatchingItemImages.vue?vue&type=script&lang=js"
export * from "./MatchingItemImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports